var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('fa',{attrs:{"icon":"search"}}),_vm._v(" 404 NOT FOUND ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }